// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"849b271e","732":"651dabc3","977":"d5f2f6f8"}[chunkId] + ".chunk.js";
};